/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const CompanyResearchJobConfig = core.serialization.object({
    onboardingId: core.serialization.string(),
    url: core.serialization.string().optional(),
    companyName: core.serialization.string().optional(),
});
